
import { IDicomImage, IFileListItem } from "@/models/file";
import { defineComponent, onMounted, onUpdated, PropType, reactive, Ref, ref, watch } from "vue";
import $API from "@/services";
import { DataType, FileType } from "@/services/file";
import Sidebar from "primevue/sidebar";
import ProgressSpinner from "primevue/progressspinner";

import { onBeforeRouteLeave } from "vue-router";
import Dialog from "primevue/dialog";
import Dicom from "@/services/dicom";

export default defineComponent({
  name: "File Viewer",
  props: {
    select: {
      type: Object as PropType<IFileListItem>,
      required: false,
    },
    isSidebar: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const state = reactive({
      select: props.select as IFileListItem,
      visibleFull: false,
      images: [] as Array<IDicomImage>,
      isLoading: false,
      isSlidebar: !!props.isSidebar,
    });

    const imageRef = ref(null);

    const srcDicomViewer = ref("");
    const titleDicomViewer: Ref<String> = ref("");
    const showDicomViewer = ref(false);

    const video$: Ref<HTMLVideoElement | null> = ref(null);

    /**
     * 뒤로가기 시 전체화면이면 전체화면만 종료, 아니면 뒤로가기
     */
    onBeforeRouteLeave((to, from, next) => {
      if (state.visibleFull) {
        state.visibleFull = false;
        next(false);
      } else if (showDicomViewer.value) {
        showDicomViewer.value = false;
        next(false);
      } else next();
    });

    onMounted(async () => {
      console.log("onMounted: imageRef=>", imageRef);
      console.log("onMounted: imageRef.value=>", imageRef.value);
      console.log("props.select?.DataType", props.select?.DataType);

      if (props.select?.DataType === DataType.IMAGE) {
        state.isLoading = true;
        try {
          const blob = await $API.FileService.getFileBlob(props.select?.FileKey?.toString());
          var urlCreator = window.URL || window.webkitURL;
          var imageUrl = urlCreator.createObjectURL(blob);
          const img = document.getElementById("imageRef");
          if (img) {
            img.setAttribute("src", imageUrl);
          }
          state.isLoading = false;
        } catch (ex) {
          state.isLoading = false;
        }
      }
    });

    onUpdated(async () => {
      if (props.select?.FileKey === state.select.FileKey) return;
      state.select = props.select as IFileListItem;
      if (state.select.DataType === DataType.VIDEO) {
        video$.value?.load();
        video$.value?.play();
      }
    });

    const viewDicom = async () => {
      const studyKeys = await Dicom.getStudyKeys(state.select.FileKey.toString());

      if (studyKeys && Array.isArray(studyKeys)) {
        state.images = await Dicom.getDicomImage(studyKeys);
      }
    };

    /**
     * 선택한 파일이 dicom이면 다이콤뷰어 open
     */
    const displayFile = async () => {
      if (state.select.DataType === DataType.DICOM) {
        state.isLoading = true;
        await viewDicom();
        state.isLoading = false;
      }
    };

    /**
     * pdf iframe 로드 후 height 조절
     */
    const pdfIframeLoad = () => {
      setTimeout(() => {
        const pdfIframe = document.querySelector("#pdfIframe") as HTMLIFrameElement;
        if (!pdfIframe) return;
        const pdfIframeContent = pdfIframe.contentWindow;
        if (!pdfIframeContent) return;
        const page = pdfIframeContent.document.querySelector(".page") as HTMLDivElement;
        if (!page) return;
        pdfIframe.style.height = page.scrollHeight + 100 + "px";
      }, 1000);
    };

    watch(
      () => state.select,
      async () => {
        await displayFile();
      }
    );
    displayFile();

    const dicomViewerPath = `${$API.BaseURL}/DicomViewer?studyKey=`;

    return {
      state,
      DataType,
      FileType,
      dicomViewerPath,
      video$,
      srcDicomViewer,
      titleDicomViewer,
      showDicomViewer,
      pdfIframeLoad,
    };
  },
  methods: {
    /**
     * image인 경우 path
     */
    getImageData(fileKey: string) {
      //return $API.FileService.getFilePath(filePath);
      return $API.FileService.getFileBlob(fileKey);
    },
    /**
     * image인 경우 path
     */
    getImagePath(filePath: string) {
      return $API.FileService.getFilePath(filePath);
      //return $API.FileService.getFileBlob(filePath);
    },

    /**
     * pdf인 경우 path, pdf view로 open
     */
    getPdfPath(filePath: string) {
      return $API.FileService.getPdfPath(filePath);
    },
    /**
     * dicom인 경우 path
     */
    openDicomViewer(fileItem: IFileListItem, studyKey: number) {
      this.srcDicomViewer = this.dicomViewerPath + studyKey + "&opts=noclose";
      this.titleDicomViewer = fileItem.Title;

      this.showDicomViewer = true;
    },
  },

  components: {
    Sidebar,
    Dialog,
    ProgressSpinner,
  },
});
